import { render } from "./job-opportunity.vue?vue&type=template&id=23cdc160"
import script from "./job-opportunity.vue?vue&type=script&lang=js"
export * from "./job-opportunity.vue?vue&type=script&lang=js"
script.render = render

export default script